import { Component } from 'react';
import { FaLinkedin, FaEnvelope, FaPhoneAlt, FaInstagram } from 'react-icons/fa';
import Header from '../Header';
import Footer from '../Footer';
import './index.css';

const OPPORTUNITY_TYPES = [
  'Freelance Project',
  'Full-Time Job',
  'Internship',
  'Python Tutoring',
  'LLM / AI Project',
  'Technical Content',
  'Other',
];

class Contact extends Component {
  state = {
    Email: '',
    Message: '',
    Name: '',
    OpportunityType: 'Freelance Project',
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  onClickContactForm = async (event) => {
    event.preventDefault();
    const { Name, Message, Email, OpportunityType } = this.state;
    try {
      const details = { Name, Message, Email, OpportunityType };
      const options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(details),
      };
      const result = await fetch('http://localhost:3010/send-email-message', options);
      const responseData = await result.json();
      if (result.ok) {
        this.setState({
          Email: '',
          Name: '',
          Message: '',
          OpportunityType: 'Freelance Project',
        }, () => {
          alert('Message sent successfully! I\'ll get back to you soon.');
        });
      } else {
        alert(`Message was not sent: ${responseData}`);
      }
    } catch (error) {
      console.log('Failed to send the message', error);
      alert('Could not reach the server. Please email me at naveenjanapati65@gmail.com');
    }
  };

  render() {
    return (
      <div className="main-container">
        <Header />
        <div className="page-content">
          <h2 className="section-heading">Let&apos;s Work Together</h2>
          <p className="section-subheading">
            Hiring for a freelance project, full-time role, internship, or tutoring? I respond quickly and deliver on time.
          </p>

          <div className="contact-opportunity-banner glass-card">
            <span className="banner-label">Currently open to</span>
            <div className="banner-tags">
              <span>Freelance</span>
              <span>Full-Time</span>
              <span>Internship</span>
              <span>Tutoring</span>
              <span>Contract</span>
            </div>
          </div>

          <div className="contact-layout">
            <div className="contact-info glass-card">
              <h3 className="contact-info-title">Reach Me Directly</h3>
              <div className="contact-details">
                <a href="mailto:naveenjanapati65@gmail.com" className="contact-item">
                  <FaEnvelope className="contact-icon" />
                  <span>naveenjanapati65@gmail.com</span>
                </a>
                <a href="tel:+919618795265" className="contact-item">
                  <FaPhoneAlt className="contact-icon" />
                  <span>+91 9618795265</span>
                </a>
                <a
                  href="https://www.linkedin.com/in/venkata-naveen-kumar-janapati/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-item"
                >
                  <FaLinkedin className="contact-icon" />
                  <span>LinkedIn Profile</span>
                </a>
                <a href = "https://www.instagram.com/naveen.learns/" target="_blank" rel="noopener noreferrer" className="contact-item">
                  <FaInstagram className="contact-icon" />
                  <span>Instagram — 6,000+ followers (Python educator)</span>
                </a>
              </div>
              <div className="contact-trust">
                <p><strong>5 months</strong> Chegg SME · <strong>15+</strong> live projects · <strong>B.Tech 2026</strong></p>
              </div>
            </div>

            <form className="contact-form glass-card" onSubmit={this.onClickContactForm}>
              <h3 className="contact-info-title">Send a Project Inquiry</h3>
              <select
                name="OpportunityType"
                className="form-input form-select"
                value={this.state.OpportunityType}
                onChange={this.handleChange}
                required
              >
                {OPPORTUNITY_TYPES.map((type) => (
                  <option key={type} value={type}>{type}</option>
                ))}
              </select>
              <input
                type="text"
                placeholder="Your Name"
                name="Name"
                className="form-input"
                value={this.state.Name}
                onChange={this.handleChange}
                required
              />
              <input
                type="email"
                placeholder="Your Email"
                name="Email"
                className="form-input"
                value={this.state.Email}
                onChange={this.handleChange}
                required
              />
              <textarea
                placeholder="Describe your project, timeline, budget, or role details..."
                name="Message"
                className="form-textarea"
                value={this.state.Message}
                onChange={this.handleChange}
                required
              />
              <button type="submit" className="btn-primary form-button">Send Inquiry</button>
            </form>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Contact;
